import React, { useCallback, useState, useEffect }  from 'react';
import { useSelector, useDispatch } from 'react-redux'


/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';

// Components
import Max2Contract from './contract';
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';
import { setContractId } from '../../appSlice';
import { hideSidebar, abortEdit, setContractData } from './contractSlice';
import { setSubPage, setSubPage2 } from '../menu/menuSlice';

// SystemData
import { optionsSeason } from './systemdata';

// SemanticUI components
import { Container, Button, Segment, Form, SidebarPushable, Sidebar, SidebarPusher, MenuItem, Menu, Divider, FormSelect, List, ListItem, ListContent, ListHeader, ListDescription, Header, HeaderContent, Icon, Modal, FormGroup, FormRadio } from 'semantic-ui-react';

// Styles
import 'semantic-ui-css/semantic.min.css'


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';
registerLocale('de', de);
setDefaultLocale('de');




const Max2CopyContractResponse = ({ response, closeModalFunc }) => {
  const dispatch = useDispatch();
  if (!response) {
    return <></>;
  }


  /**
   * 
   * @param {integer} cid 
   */
  const handleOpenContractClick = (cid, new_contract) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());

    dispatch(setContractId(cid));
    dispatch(setContractData({ target: 'ALL', value: new_contract.Contract }));
    dispatch(setSubPage(new_contract.Contract.Basics.Hotelcode));
    dispatch(setSubPage2('Vertrag ' + new_contract.Contract.Basics.Season.text));

    closeModalFunc()
  }

  if (response.new_id) {
    if (!response.messages.length) {
      return (
        <Segment>
          <Header as='h2' textAlign='center'>
            <Icon name='check circle outline' />
            <HeaderContent>
              Vertrag erfolgreich kopiert
            </HeaderContent>
          </Header>

          <Container style={{textAlign: 'center', marginTop: '20px', marginBottom: '20px'}}>
            <p style={{textAlign: 'center'}}>Die Vertragskopie hat die ID <strong>{response.new_id}</strong>.</p>
            <Button primary circular style={{width:'200px', margin: '5px'}} onClick={()=>handleOpenContractClick(response.new_id, response.new_contract)}>Neuen Vertrag öffnen</Button>
          </Container>
        </Segment>
      );
    } else {
      return (
        <Segment>
          <Header as='h2' textAlign='center'>
            <Icon name='warning circle' />
            <HeaderContent>
              Vertrag mit Warnungen kopiert
            </HeaderContent>
          </Header>
          {response.messages && response.messages.length > 0 && (
            <List bulleted>
              {response.messages.map((msg, idx) => {
                const message = msg.message ? msg : msg.text;
                const error = msg.error ? 'Error: ' + msg.error : false;
                return <ListItem key={idx} title={error}>{message}</ListItem>
              })}
            </List>
          )}
          <Container style={{textAlign: 'center', marginTop: '40px', marginBottom: '20px'}}>
            <p style={{textAlign: 'center'}}>Die Vertragskopie hat die ID <strong>{response.new_id}</strong>.</p>
            <Button primary circular style={{width:'200px', margin: '5px'}} onClick={()=>handleOpenContractClick(response.new_id, response.new_contract)}>Neuen Vertrag öffnen</Button>
          </Container>
        </Segment>
      );
    }
  }


  return (
    <Segment>
      <Header as='h2' textAlign='center'>
        <Icon name='times circle outline' />
        <HeaderContent>
          Vertrag konnte nicht kopiert werden
        </HeaderContent>
      </Header>
      {response.messages && response.messages.length > 0 && (
      <>
        <List bulleted>
          {response.messages.map((message, idx) => {
            return (<ListItem key={idx} title={"Error: "+message.error}>{message.message}</ListItem>)
          })}
        </List>
      </>
    )}
    </Segment>
  );
}





/**
 * 
 * @returns 
 */
const Max2PageContract = () => {
  // local State
  const [expandListPDF, setExpandListPDF]             = useState(false);
  const [expandListEDF, setExpandListEDF]             = useState(false);
  const [copyContract, setCopyContract]               = useState(false);
  const [copyResponse, setCopyResponse]               = useState(false);
  const [sendingPDF, setSendingPDF]                   = useState(false);
  const [generatePDF, setGeneratePDF]                 = useState(false);
  const [generateEDF, setGenerateEDF]                 = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationErrors, setValidationErrors]       = useState([]);
  const [showCopyModal, setShowCopyModal]             = useState(false);
  const [copyOptions, setCopyOptions]                 = useState({hotelcode: null, season: null, method: null, areas: []});
  const [options, setOptions]                         = useState([]);
  const [optionsSub, setOptionsSub]                   = useState([]);
  const [isLoading, setIsLoading]                     = useState(false);
  const [searchQuery, setSearchQuery]                 = useState(null); 
  const [copyMethod, setCopyMethod]                   = useState(null);
  const [isLoaded, setIsLoaded]                       = useState(false);

  // global State
  const dispatch = useDispatch();
  const isSidebar   = useSelector((state) => state.contract.isSidebar);
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const contractId  = useSelector((state) => state.app.contractId);
  const Contract    = useSelector((state) => state.contract.data.Contract);
  const allSeasons  = useSelector((state) => state.contract.data.AllSeasons);
  const user = useSelector((state) => state.app.user);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // Copy Method Options
  const optionsCopyMethod = [
    { key: 1, value: 1, text: 'mit allen Preisen'},
    { key: 2, value: 2, text: 'ohne Preisen'}
  ]

  // Copy Section Options
  const optionsCopySections = [
    { key: 1, value: 'basis', text: 'Basisdaten'},
    { key: 2, value: 'saison', text: 'Saisons'},
    { key: 3, value: 'zimmer', text: 'Zimmer'},
    { key: 4, value: 'verpflegung', text: 'Verpflegungszuschläge'},
    { key: 5, value: 'sonderangebote', text: '(Vertrags-)Specials'}
  ]

  // filter season options 
  let filteredOptionsSeason = [];
  optionsSeason.forEach(season => {
    let found = false;
    allSeasons.forEach(seasonId => {
      if (seasonId === season.value) {
        found = true;
      }
    });
    if (!found) {
      filteredOptionsSeason.push(season);
    }
  });



  /**
   * Get filtered hotelcodes from server
   * 
   * @param {String} query 
   * @param {String} url 
   */
  const fetchOptions = async (query, url, callbackFn) => {
    try {
      const api = new AjaxController(url, () => {
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });
      const hotelcodes = await api.get('/hotelcodes/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
      if (typeof callbackFn !== 'undefined') {
        callbackFn(hotelcodes)
      }
    } catch (error) {
      console.error("Fehler beim Laden der Optionen:", error);
      return false
    }
  };




  const loadHotelcodesSub = () => {

    const callbackFn = (hotelcodes) => {
      //
      if (!hotelcodes) {
        setOptions([]);
        setIsLoading(false);
        return;
      }

      function findSimilar(codes, referenzCode) {
        const prefix = referenzCode.slice(0, -1);

        return codes.filter(item => {
          const code = item.key; // oder item.value

          // darf nicht der Referenzcode selbst sein
          if (code === referenzCode) return false;

          // Länge muss übereinstimmen
          if (code.length !== referenzCode.length) return false;

          // gleicher Prefix?
          if (!code.startsWith(prefix)) return false;

          // nur letzter Buchstabe
          const suffix = code.slice(-1);
          return /^[A-Z]$/i.test(suffix); // nur Buchstaben zulassen
        });
      }

      const similar = findSimilar(hotelcodes, Contract?.Basics?.Hotelcode);
      setOptionsSub(similar);
      setIsLoaded(true);
    }
    
    // 
    const searchQuery = Contract?.Basics?.Hotelcode.slice(0, -1);
    fetchOptions(searchQuery, backendUrl, callbackFn);

  }


  // Initialize hotelcode list
  useEffect(() => {
    if (copyMethod === 'SUBCODE' && Contract?.Basics?.Hotelcode && !isLoaded) {
      loadHotelcodesSub(contractId);
    }
  }, [Contract, copyMethod, isLoaded, contractId, loadHotelcodesSub]);



  /**
   * Handle input change in Dropdown
   * 
   * @param {Event} e 
   * @param {String} searchQuery 
   */
  const handleSearchChange = (e, { searchQuery }) => {
    setSearchQuery(searchQuery);
    setIsLoading(true);


    const callbackFn = (hotelcodes) => {
      //
      if (!hotelcodes) {
        setOptions([]);
        setIsLoading(false);
        return;
      }

      // filter hotelcodes
      if (typeof user.objectCodes !== 'undefined' && user.objectCodes.length) {
        let optionsHotelcode = [];
        hotelcodes.forEach(hotelcode => {
          user.objectCodes.forEach(objectCode => {
            if (hotelcode.value === objectCode.name) {
              optionsHotelcode.push(hotelcode);
            }
          });
        });
        hotelcodes = optionsHotelcode;
      }
      setOptions(hotelcodes);
    }

    // Load options after 3 or more characters
    if (searchQuery.length >= 3) {
      fetchOptions(searchQuery, backendUrl, callbackFn);
    } else {
      setOptions([]);
    }

    // hide Loading animation
    setIsLoading(false);
  };



  /**
   * @async
   * Creates a PDF of the contract and opens it in a new tab.
   * @param {string} contractId - The ID of the contract to create a PDF for.
   * @returns {Promise<void>}
   * @throws Will throw an error if the PDF creation fails or if the pop-up is blocked.
   * @description This function uses the AjaxController to send a request to the backend to create a PDF of the contract.
   * If successful, it opens the PDF in a new tab. If the pop-up blocker is enabled, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * 
   * @example
   * createPDF(12345);
   * 
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.  
   */
  const sendPDF = useCallback(async (contractId) => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // show loading animation
    setSendingPDF(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    try {
      response = await api.get('/contract/' + contractId + '/sendpdf');
    } catch (error) {
      console.error('Error creating PDF:', error);
      enqueueSnackbar('Fehler beim Versenden des PDF. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setSendingPDF(false);
      return;
    }

    // show pdf in a new tab
    if (response?.pdfUrl) {
      const newTab = window.open(response.pdfUrl, '_blank');
      if (!newTab) {
        enqueueSnackbar('Pop-up Blocker ist aktiviert. Bitte erlauben Sie Pop-ups für diese Seite.', { variant: 'error' });
      }
      enqueueSnackbar('PDF wurde erfolgreich erstellt.', { variant: 'success' });
    } else {
      enqueueSnackbar('Failed to create PDF. Please try again later.', { variant: 'error' });
      // hide loading animation
      setSendingPDF(false);

      return false;
    }

    // generate EDF
    let responseEDF;
    try {
      responseEDF = await api.get('/contract/' + contractId + '/edf-hotel');
    } catch (error) {
      console.error('Error creating EDF for HOTEL:', error);
      enqueueSnackbar('Fehler beim Erstellen des Hotel-EDF. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setSendingPDF(false);
      return;
    }

    // Check validation errors
    if (responseEDF?.validationErrors && responseEDF.validationErrors.length > 0) {
      setValidationErrors(responseEDF.validationErrors);
      setShowValidationModal(true);
    }

    // Update contract data with new PDFs
    const responsePDFs = await api.get('/contract/' + contractId + '/pdfs');
    if (responsePDFs?.PDFs) {
      dispatch(setContractData({ target: 'PDF', value: responsePDFs.PDFs }));

      // hide loading animation
      setSendingPDF(false);
    }

  }, [backendUrl, dispatch, enqueueSnackbar]);




  /**
   * @async
   * Creates a PDF of the contract and opens it in a new tab.
   * @param {string} contractId - The ID of the contract to create a PDF for.
   * @returns {Promise<void>}
   * @throws Will throw an error if the PDF creation fails or if the pop-up is blocked.
   * @description This function uses the AjaxController to send a request to the backend to create a PDF of the contract.
   * If successful, it opens the PDF in a new tab. If the pop-up blocker is enabled, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * 
   * @example
   * createPDF(12345);
   * 
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.  
   */
  const createPDF = useCallback(async (contractId) => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // show loading animation
    setGeneratePDF(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    try {
      response = await api.get('/contract/' + contractId + '/pdf');
    } catch (error) {
      console.error('Error creating PDF:', error);
      enqueueSnackbar('Fehler beim Erstellen des PDF. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setGeneratePDF(false);
      return;
    }
    

    // show pdf in a new tab
    if (response?.pdfUrl) {
      const newTab = window.open(response.pdfUrl, '_blank');
      if (!newTab) {
        enqueueSnackbar('Pop-up Blocker ist aktiviert. Bitte erlauben Sie Pop-ups für diese Seite.', { variant: 'error' });
      }
      enqueueSnackbar('PDF wurde erfolgreich erstellt.', { variant: 'success' });
    } else {
      enqueueSnackbar('Failed to create PDF. Please try again later.', { variant: 'error' });
      // hide loading animation
      setGenerateEDF(false);

      return false;
    }

    // Update contract data with new PDFs
    const responsePDFs = await api.get('/contract/' + contractId + '/pdfs');
    if (responsePDFs?.PDFs) {
      dispatch(setContractData({ target: 'PDF', value: responsePDFs.PDFs }));

      // hide loading animation
      setGeneratePDF(false);
    }

  }, [backendUrl, dispatch, enqueueSnackbar]);




  /**
   * @async
   * Creates a EDF of the contract and opens it in a new tab.
   * @param {string} contractId - The ID of the contract to create a PDF for.
   * @param {string} type - The type of EDF to create, either 'HOTEL' or 'ALLOTMENT'.
   * @returns {Promise<void>}
   * @throws Will throw an error if the PDF creation fails or if the pop-up is blocked.
   * @description This function uses the AjaxController to send a request to the backend to create a PDF of the contract.
   * If successful, it opens the PDF in a new tab. If the pop-up blocker is enabled, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * 
   * @example
   * createEDF(12345, 'HOTEL);
   * 
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.  
   */
  const createEDF = useCallback(async (contractId, type = 'HOTEL') => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // show loading animation
    setGenerateEDF(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    switch (type.toUpperCase()) {
      case 'HOTEL':
        try {
          response = await api.get('/contract/' + contractId + '/edf-hotel');
        } catch (error) {
          console.error('Error creating EDF for HOTEL:', error);
          enqueueSnackbar('Fehler beim Erstellen des Hotel-EDF. Bitte versuchen Sie es später erneut.', { variant: 'error' });
          setGenerateEDF(false);
          return;
        }
        break;
      
      case 'ALLOTMENT':
        try {
          response = await api.get('/contract/' + contractId + '/edf-allotment');
        } catch (error) {
          console.error('Error creating EDF for ALLOTMENT:', error);
          enqueueSnackbar('Fehler beim Erstellen des Allotment-EDF. Bitte versuchen Sie es später erneut.', { variant: 'error' });
          setGenerateEDF(false);
          return;
        }
        break;

      default:
        response = await api.get('/contract/' + contractId + '/edf-hotel');
        break;
    }

    // Check validation errors
    if (response?.validationErrors && response.validationErrors.length > 0) {
      setValidationErrors(response.validationErrors);
      setShowValidationModal(true);
    }

    // Update contract data with new EDFs
    const responseEDFs = await api.get('/contract/' + contractId + '/edfs');
    if (responseEDFs?.EDFs) {
      dispatch(setContractData({ target: 'EDF', value: responseEDFs.EDFs }));
      
      // hide loading animation
      setGenerateEDF(false);
    }

  }, [backendUrl, dispatch, enqueueSnackbar]);



  /**
   * @async
   * Locks the contract by sending a request to the backend.
   * @param {integer} contractId - The ID of the contract to lock.
   * @returns {Promise<void>}
   * @throws Will throw an error if the locking fails or if the contractId is invalid.
   * @description This function uses the AjaxController to send a request to the backend to lock the contract.
   * If successful, it shows a success message. If an error occurs, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * 
   * @example
   * lockContract(12345);
   * 
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.
   * @memberof Max2PageContract
   */
  const lockContract = useCallback(async (contractId) => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    //
    try {
      await api.get('/contract/' + contractId + '/lock');
      enqueueSnackbar('Vertrag freigegeben.', { variant: 'success' });
      dispatch(setContractData({target: 'Status', value: 3}));

    } catch (error) {
      console.error('Error locking contract:', error);
      enqueueSnackbar('Fehler beim Setzen der Freigabe. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setGenerateEDF(false);
      return;
    }

  }, [backendUrl, dispatch, enqueueSnackbar]);



  /**
   * @async
   * Locks the contract by sending a request to the backend.
   * @param {integer} contractId - The ID of the contract to unlock.
   * @returns {Promise<void>}
   * @throws Will throw an error if the locking fails or if the contractId is invalid.
   * @description This function uses the AjaxController to send a request to the backend to lock the contract.
   * If successful, it shows a success message. If an error occurs, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * 
   * @example
   * lockContract(12345);
   * 
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.
   * @memberof Max2PageContract
   */
  const unlockContract = useCallback(async (contractId) => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    try {
      await api.get('/contract/' + contractId + '/unlock');
      enqueueSnackbar('Vertragsfreigabe aufgehoben.', { variant: 'success' });
      dispatch(setContractData({target: 'Status', value: 0}));

    } catch (error) {
      console.error('Error unlocking contract:', error);
      enqueueSnackbar('Fehler beim Entfernen der Freigabe. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setGenerateEDF(false);
      return;
    }

  }, [backendUrl, dispatch, enqueueSnackbar]);



  /**
   * @async
   * Creates a copy of the contract by sending a request to the backend.
   * @param {integer} contractId - The ID of the contract to copy.
   * @returns {Promise<void>}
   * @throws Will throw an error if the copying fails or if the contractId is invalid.
   * @description This function uses the AjaxController to send a request to the backend to copy the contract.
   * If successful, it shows a success message. If an error occurs, it shows an error message.
   * It is wrapped in a useCallback to prevent unnecessary re-renders.
   * @example
   * copyContract(12345);
   * @see AjaxController for AJAX requests.
   * @see useSnackbar for displaying notifications.
   * @memberof Max2PageContract
   */
  const copyContractClick = useCallback(async (contractId) => {
    if (!contractId) {
      enqueueSnackbar('Kein Vertrag ausgewählt', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // Check if contractId is valid
    if (isNaN(contractId)) {
      enqueueSnackbar('Ungültige Vertrags-ID', { variant: 'error' });
      return;
    }

    // show loading animation
    setCopyContract(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    try {
      let params = {...copyOptions, CopyMethod: copyMethod, HotelcodeFilter: Contract?.Basics?.Hotelcode};
      response = await api.post('/contract/' + contractId + '/copy', params);
      setCopyResponse(response);
    } catch (error) {
      console.error('Error creating PDF:', error);
      enqueueSnackbar('Fehler beim Kopieren des Vertrages. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setCopyContract(false);
      return;
    }
    
    //
    setCopyContract(false);

  }, [backendUrl, copyOptions, copyMethod, Contract, dispatch, enqueueSnackbar]);



  /**
   * 
   * Opens the copy contract modal.
   */
  const handleOpenCopyModalClick = () => {
    //setCopyMethod(type);
    setCopyResponse(false);
    setShowCopyModal(true);
  }


  
  /**
   * Handles the file download by logging the file information.
   * 
   * @param {*} file 
   */
  const handleFileDownload = (file) => {
    if (file) {
      window.open(file, '_blank');
    }
  }


  // build pdf items
  const pdfs = typeof Contract?.PDF === 'undefined' ? <></> : Contract?.PDF.map((file, fileKey) => {
    const fdateAt = file?.CreatedAt ? format(new Date(file?.CreatedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
    const fdateBy = file?.CreatedBy ? file?.CreatedBy : '';
    if (!expandListPDF && fileKey > 4) {
      return <></>;
    }
    return (
      <ListItem key={fileKey}>
        <ListContent style={{textAlign: 'left'}}>
          <ListHeader as='a' onClick={()=>{handleFileDownload(file.Filepath)}}>{file.Filename}</ListHeader>
          <ListDescription as='a'>{fdateAt}, {fdateBy}</ListDescription>
        </ListContent>
      </ListItem>
    );
  });


  // build edf items
  const edfs = typeof Contract?.EDF === 'undefined' ? <></> : Contract?.EDF.map((file, fileKey) => {
    const fdateAt = file?.CreatedAt ? format(new Date(file?.CreatedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
    const fdateBy = file?.CreatedBy ? file?.CreatedBy : '';
    if (!expandListEDF && fileKey > 4) {
      return <></>;
    }
    return (
      <ListItem key={fileKey}>
        <ListContent style={{textAlign: 'left'}}>
          <ListHeader as='a' onClick={()=>{handleFileDownload(file.Filepath)}}>{file.Filename}</ListHeader>
          <ListDescription as='a'>{fdateAt}, {fdateBy}</ListDescription>
        </ListContent>
      </ListItem>
    );
  });


  // Main render
  return (
    <>
      {/* Modal für Kopierfunktion */}
      <Modal
        closeIcon
        open={showCopyModal}
        onClose={() => setShowCopyModal(false)}
        size='medium'
      >
        <Header icon='copy outline' content='Vertrag kopieren' />
        <Modal.Content>
            {copyResponse 
            ? <Max2CopyContractResponse response={copyResponse} closeModalFunc={() => {setShowCopyModal(false)}} /> 
            : <>
              {copyContract 
                ? (
                  <Segment>
                    <Header as='h2' textAlign='center'>
                      <Icon loading name='spinner' />
                      <HeaderContent>
                        Vertrag wird kopiert...
                      </HeaderContent>
                    </Header>
                  </Segment>
                )
                : (
                  <>
                    <Segment>
                      <Header as='h2' textAlign='center'>
                        <Icon name='cogs' />
                        <HeaderContent>
                          Methode
                        </HeaderContent>
                      </Header>
                      <Form>
                        <FormGroup inline>
                          <FormRadio label='neue Saison'              value='SEASON'    checked={copyMethod === 'SEASON'}   onChange={()=>setCopyMethod('SEASON')} />
                          <FormRadio label='neuer Hotelcode'          value='CODE'      checked={copyMethod === 'CODE'}     onChange={()=>setCopyMethod('CODE')} />
                          <FormRadio label='neues Teilkontingent'     value='SUBCODE'   checked={copyMethod === 'SUBCODE'}  onChange={()=>{ setCopyMethod('SUBCODE');  setCopyOptions({...copyOptions, season: Contract.Basics.Season.value}); }} />
                          <FormRadio disabled label='auf bestehenden Vertrag'  value='EXISTING'  checked={copyMethod === 'EXISTING'} onChange={()=>setCopyMethod('EXISTING')} />
                        </FormGroup>
                      </Form>
                    </Segment>

                    {copyMethod && (
                      <Segment>
                        <Header as='h2' textAlign='center'>
                          <Icon name='cogs' />
                          <HeaderContent>
                            Parameter
                          </HeaderContent>
                        </Header>
                        <Form>
                          {copyMethod === 'SUBCODE'
                            ? <FormSelect 
                                search 
                                selection 
                                label             = "Hotelcode" 
                                placeholder       = 'bitte wählen' 
                                value             = {copyOptions.hotelcode} 
                                options           = {optionsSub} 
                                loading           = {isLoading}
                                noResultsMessage  = {!searchQuery || searchQuery.length < 3 ? "Bitte geben Sie mindestens 3 Zeichen ein" : "Keine Ergebnisse gefunden"}
                                onSearchChange    = {handleSearchChange}
                                onChange          = {(e, data) => setCopyOptions({...copyOptions, hotelcode: data.value})} 
                              />
                            : <></>
                          }
                          {copyMethod === 'CODE' || copyMethod === 'EXISTING'
                            ? <FormSelect 
                                search 
                                selection 
                                label             = "Hotelcode" 
                                placeholder       = 'bitte wählen' 
                                value             = {copyOptions.hotelcode} 
                                options           = {options} 
                                loading           = {isLoading}
                                noResultsMessage  = {!searchQuery || searchQuery.length < 3 ? "Bitte geben Sie mindestens 3 Zeichen ein" : "Keine Ergebnisse gefunden"}
                                onSearchChange    = {handleSearchChange}
                                onChange          = {(e, data) => setCopyOptions({...copyOptions, hotelcode: data.value})} 
                              />
                            : <></>
                          }
                          {copyMethod === 'SUBCODE'
                            ? <></>
                            : <FormSelect search selection label="Zielsaison" value={copyOptions.season} options={filteredOptionsSeason} placeholder='bitte wählen' onChange={(e, data) => setCopyOptions({...copyOptions, season: data.value})} />
                          }
                          <FormSelect search selection label="Preise" value={copyOptions.method} options={optionsCopyMethod} placeholder='bitte wählen' onChange={(e, data) => setCopyOptions({...copyOptions, method: data.value})} />
                          <FormSelect search selection multiple label="Bereiche" value={copyOptions.areas} options={optionsCopySections} placeholder='bitte wählen' onChange={(e, data) => setCopyOptions({...copyOptions, areas: data.value})} />
                          <br />
                          <br />
                          <Button basic circular style={{width:'200px', margin: '5px'}} onClick={() => {setShowCopyModal(false); setCopyOptions({season: null, method: null, areas: []}); }}>abbrechen</Button>
                          {copyOptions.season && copyOptions.method && copyOptions.areas.length 
                            ? <Button primary circular floated='right' style={{width:'200px', margin: '5px'}} onClick={() => copyContractClick(contractId)}>kopieren</Button> 
                            : <Button disabled primary circular floated='right' style={{width:'200px', margin: '5px'}}>kopieren</Button>
                          }
                        </Form>
                      </Segment>
                    )}
                  </>
                )
              }
              </>
            }
        </Modal.Content>
      </Modal>


      {/* Modal für Validierungsfehler */}
      <Modal
        open={showValidationModal}
        onClose={() => setShowValidationModal(false)}
        size='medium'
      >
        <Header icon='exclamation triangle' content='Ungültige Daten in der EDF-Datei' />
        <Modal.Content>
          <Segment>
            <p>Die generierte EDF-Datei enthält folgende ungültige Daten:</p>
            <List bulleted>
              {validationErrors.map((error, idx) => (
                <ListItem key={idx}>{error.message.replace('{http://www.vilauma.de/edf/Hotel}', '')}</ListItem>
              ))}
            </List>
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button basic circular onClick={() => setShowValidationModal(false)}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>


      {/* Sidebar für Aktionen */}
      <SidebarPushable as={Segment}>
        <Sidebar
          vertical
          as        = {Menu}
          animation = 'overlay'
          direction = 'right'
          icon      = 'labeled'
          visible   = {isSidebar}
          width     = 'wide'
          onHide    = {() => dispatch(hideSidebar())}
        >
          <MenuItem>
            <Container>
              <Divider horizontal>Aktionen</Divider>
              { Contract?.Status?.STATUS === '3' 
              ? (<Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => unlockContract(contractId)}>Freigabe widerrufen</Button>)
              : (<Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => lockContract(contractId)}>Freigabe setzen</Button>)
              }
              <br /><br />
              {sendingPDF && (
                <Header as='h2' textAlign='center'>
                  <Icon loading name='spinner' />
                  <HeaderContent>
                    PDF wird generiert und versendet...
                  </HeaderContent>
                </Header>
              )}
              {!sendingPDF && (
                <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => sendPDF(contractId)}>PDF versenden</Button>
              )}

              <br /><br />

              <Divider horizontal>Vertragskopie</Divider>
              {copyContract 
                ? <></> 
                : <>
                  <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => handleOpenCopyModalClick()}>Kopieren</Button>
                  {/*<Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => handleOpenCopyModalClick('SEASON')}>als neue Saison</Button>
                  <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => handleOpenCopyModalClick('CODE')}>als neuer Hotelcode</Button>
                  <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => handleOpenCopyModalClick('SUBCODE')}>als Teilkontingent</Button>
                  <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => handleOpenCopyModalClick('EXISTING')}>Auf bestehenden Vertrag</Button>*/}
                  </> 
              }

              <br /><br />

              <Divider horizontal>Vertrags-PDFs</Divider>
              {generatePDF && (
                <Header as='h2' textAlign='center'>
                  <Icon loading name='spinner' />
                  <HeaderContent>
                    PDF wird generiert ...
                  </HeaderContent>
                </Header>
              )}
              {!generatePDF && (
                <>
                <List divided relaxed>
                  {pdfs}
                </List>
                <br />
                {!expandListPDF && Contract?.PDF?.length > 5 && (<Button basic circular onClick={()=>setExpandListPDF(true)}>mehr ...</Button>)}
                {expandListPDF && (<Button basic circular onClick={()=>setExpandListPDF(false)}>weniger ...</Button>)}
                <br />
                <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => createPDF(contractId)}>PDF erzeugen</Button>
                </>
              )}

              <br /><br />

              <Divider horizontal>EDF-Exporte</Divider>
              {generateEDF && (
                <Header as='h2' textAlign='center'>
                  <Icon loading name='spinner' />
                  <HeaderContent>
                    EDF wird generiert ...
                  </HeaderContent>
                </Header>
              )}
              {!generateEDF && (
                <>
                <List divided relaxed>
                  {edfs}
                </List>
                <br />
                {!expandListEDF && Contract?.EDF?.length > 5 && (<Button basic circular onClick={()=>setExpandListEDF(true)}>mehr ...</Button>)}
                {expandListEDF && (<Button basic circular onClick={()=>setExpandListEDF(false)}>weniger ...</Button>)}
                <br />
                <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => createEDF(contractId, 'HOTEL')}>Hotel-EDF erzeugen</Button>
                <br />
                <Button primary circular style={{width:'200px', margin: '5px'}} onClick={() => createEDF(contractId, 'ALLOTMENT')}>Allotment-EDF erzeugen</Button>
                </>
              )}

              <br /><br />

              <Divider horizontal>Historie</Divider>
            </Container>
          </MenuItem>
        </Sidebar>

        <SidebarPusher dimmed={isSidebar}>
          <Max2Contract />
        </SidebarPusher>
      </SidebarPushable>
    </>
  )
}


export default Max2PageContract;